// THIS FILE WAS AUTO GENERATED, UPDATE THE i18n FILES

import { HBinput, i18nLoad } from "@cervval.js/i18n/src/i18n.tools";

export type I18nType = {
    ClientWebSocketService: {
        applicationWasUpdated: {
            link: string,
            title: string
        },
        sessionTerminated: {
            link: string,
            title: string
        }
    },
    ConnectionsListPage: {
        connectTS: string,
        displayName: string,
        navigationTS: string,
        page: string,
        rooms: string,
        serverInstanceUid: string,
        sessionTS: string,
        userUid: string
    }
};

const i18n_en = require("./_en.i18n"); // hash_en=2370847461177185#
const i18n_fr = require("./_fr.i18n"); // hash_fr=3327935203461377#

/** @returns the i18n for provided lang (fallback on app.lang if i18n not found for lang) */
export function i18n(lang?: string): I18nType {
    return i18nLoad<I18nType>(lang, ["en", "fr"], (langToLoad: string) => {
        switch (langToLoad) {
            case "en": return i18n_en;
            case "fr": return i18n_fr;
            default:
        }
        return null;
    });
}